export default __webpack_public_path__ + "static/media/periods2.243248a9.jpg";